import TMLogo from "@assets/TMLogo.svg";
import UserInfo from "@header/TopHeader/UserInfo/UserInfo";
import type { ReactElement } from "react";
import { Link } from "react-router";

export function TopHeaderMenus(): ReactElement {
  return (
    <>
      <div className="pr-1">
        <Link
          to="https://www.tamilmurasu.com.sg/"
          target="_blank"
          rel="noreferrer"
          reloadDocument
        >
          <img
            width={91}
            height={20}
            src={TMLogo}
            loading="lazy"
            className="w-auto"
            alt="tamil-murasu"
          />
        </Link>
      </div>
      <span className="text-grey-100"> | </span>
      <div className="inline-flex text-black font-bold text-sm leading-6">
        <UserInfo />
      </div>
    </>
  );
}
